import api from "./core";

const basePath = "api/core/ProviderAvailability";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  query(filter) {
    return api.post(`${basePath}`, filter);
  },
  queryMinimal(filter) {
    return api.post(`${basePath}/MinimalList`, filter);
  },
  queryMinimalPaginate(filter) {
    return api.post(`${basePath}/MinimalListPaginate`, filter);
  },
  queryMinimalCard(filter) {
    return api.post(`${basePath}/MinimalListCard`, filter);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  deleteRecurrenceFromCard(id) {
    return api.delete(`${basePath}/Recurrence/${id}`);
  },
  updateDates(id, data) {
    return api.patch(`${basePath}/UpdateDates/${id}`, data);
  }
};
